/**
 * Skippable brand intro at onboarding start.
 * Drop a file at `public/intro.mp4` (copied to site/) to enable real video;
 * without it, the animated emoji stage ships.
 */

import { useEffect, useRef, useState } from "react";
import { BrandMark } from "./BrandMark";
import { Button } from "./Button";
import { useT } from "../i18n";

const SEEN_KEY = "un8.intro.seen.v1";
const INTRO_SRC = "/intro.mp4";

export function IntroStage({ onDone }: { onDone: () => void }) {
  const t = useT();
  const videoRef = useRef<HTMLVideoElement>(null);
  const [hasVideo, setHasVideo] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(INTRO_SRC, { method: "HEAD" })
      .then((r) => {
        if (!cancelled) setHasVideo(r.ok);
      })
      .catch(() => {
        if (!cancelled) setHasVideo(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const finish = () => {
    try {
      localStorage.setItem(SEEN_KEY, "1");
    } catch {
      /* ignore */
    }
    onDone();
  };

  return (
    <div className="intro-stage screen-enter">
      <div className="intro-stage__orbit" aria-hidden />
      {hasVideo ? (
        <video
          ref={videoRef}
          src={INTRO_SRC}
          playsInline
          controls
          autoPlay
          muted
          onEnded={finish}
        />
      ) : (
        <>
          <BrandMark hero />
          <p className="intro-stage__text">{t("intro.text")}</p>
        </>
      )}
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0, width: "100%" }}>
        <Button onClick={finish}>{t("intro.continue")}</Button>
      </div>
    </div>
  );
}

export function shouldShowIntro(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) !== "1";
  } catch {
    return true;
  }
}
